import { DpFanRecommendedContent } from '@/components/blocks/DpFanRecommendedContent';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { usePostLoginDialog } from '@/data/context/postLoginDialog';
import { useIsMobile } from '@/data/hooks/useIsMobile';
import { useEffect } from 'react';
import { useDpFanUserHasInterests } from '@/data/Content/DpFan/userHasInterests';

export const POST_LOGIN_ORIGIN = 'post-login';

export const DpFanPostLoginDialog = () => {
	const { active } = usePostLoginDialog();
	const { isLoadingUserInterests, isUserLoggedIn, hasCustomInterests } = useDpFanUserHasInterests();
	const isMobile = useIsMobile();
	const router = useNextRouter();

	useEffect(() => {
		if (isMobile && active && !isLoadingUserInterests && isUserLoggedIn && !hasCustomInterests) {
			router.push({ pathname: '/quiz-estilo', query: { origin: POST_LOGIN_ORIGIN } });
		}
	}, [active, isMobile, isLoadingUserInterests, isUserLoggedIn, hasCustomInterests]);

	if (!active || isMobile) {
		return null;
	}

	return <DpFanRecommendedContent emsName="DPSV2DpFanDialog" />;
};
